export default __webpack_public_path__ + "static/media/video-icon.5103c12a.svg";